"use client";

import { useState, useEffect } from "react";

// initialValue is what the server renders with, so a good guess avoids a re-render after hydration.
export function useMediaQuery(query: string, initialValue = false): boolean {
  const [matches, setMatches] = useState<boolean>(initialValue);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    setMatches(mediaQuery.matches);

    const updateMatches = (e: MediaQueryListEvent | MediaQueryList) => {
      setMatches(e.matches);
    };

    mediaQuery.addEventListener("change", updateMatches);

    return () => {
      mediaQuery.removeEventListener("change", updateMatches);
    };
  }, [query]);

  return matches;
}
